module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phone":"Phone","mobile":"Mobile","fax":"Fax","email":"Email"},"de":{"phone":"Telefon","mobile":"Mobil","fax":"Fax","email":"Email"}}')
  delete Component.options._Ctor
}
